<!-- WEXHUB: override de componente upstream -->
<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex items-center mx-3 my-2 p-1 rounded-full bg-n-surface-active gap-0.5">
    <button v-for="item in items" :key="item.key"
      class="flex-1 flex items-center justify-center gap-1 px-2 py-1 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
      :class="item.key === activeTab
          ? 'bg-n-surface-2 text-n-iris-9 dark:text-n-iris-11 shadow-sm'
          : 'text-n-slate-10 hover:text-n-slate-12'
        " @click="emit('chatTabChange', item.key)">
      <span>{{ item.name }}</span>
      <span class="tabular-nums rounded-full px-1 py-0.5 text-[10px] font-medium transition-colors min-w-[24px]"
        :class="item.key === activeTab ? 'bg-n-iris-9/15' : ''">
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
